import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../../../../app.constants';
import { OrderDTO, TripDTO } from '../../../../interfaces/models';

@Injectable()
export class TableNavigationService {

  constructor(
    private readonly router: Router,
  ) {
  }

  public navigateToDriverLocation(driverId: string) {
    this.router.navigate([APP_ROUTES.drivers_location, driverId]);
  }

  public navigateToTrip(trip: TripDTO) {
    this.router.navigate([APP_ROUTES.trip, trip.id]);
  }

  public navigateToOrder(order: OrderDTO) {
    this.router.navigateByUrl(`${APP_ROUTES.order}/${order.id}`);
  }

  public navigateToDispatch(order: OrderDTO) {
    this.router.navigate([APP_ROUTES.dispatch, order.id]);
  }
}
